import React, { Fragment } from "react";
import { TimerIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units: Array<[string, number]> = [["Hours", hours], ["Minutes", minutes], ["Seconds", seconds]];
  return <div className="w-full" role="timer" aria-label="Promotional price countdown" data-id="element-20" data-mp="3c1mh8fg22fwl">
      <p className={`mb-2 flex items-center justify-center gap-1.5 text-sm font-bold uppercase tracking-wide ${dark ? "text-white" : "text-ink"}`} data-id="element-21" data-mp="3h1id1reln112">
        <TimerIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-22" data-mp="372t26il4egub" />
        Promotional price ends in
      </p>
      <div className="flex items-center justify-center gap-1.5 sm:gap-2" data-id="element-23" data-mp="10btpw0q09mxd">
        {units.map(([label, value], i) => <Fragment key={label} data-id="element-24" data-mp="15adde5k8z6ru" data-mpi={i}>
            <div className={`flex w-[78px] flex-col items-center rounded-xl py-2 sm:w-[88px] ${dark ? "bg-white text-navy-950" : "bg-navy-900 text-white"}`} data-id="element-25" data-mp="159c0dvjo8a7h">
              <span className="font-display text-4xl font-bold leading-none tabular-nums sm:text-5xl" data-id="element-26" data-mp="t091ku5bp5nm">
                {String(value).padStart(2, "0")}
              </span>
              <span className={`mt-1 text-[10px] font-semibold uppercase tracking-wider ${dark ? "text-muted" : "text-white/60"}`} data-id="element-27" data-mp="12solvy43e6bo">
                {label}
              </span>
            </div>
            {i < units.length - 1 && <span className="font-display text-3xl font-bold text-alert" aria-hidden="true" data-id="element-28" data-mp="o4bp4yx6kjg4">
                :
              </span>}
          </Fragment>)}
      </div>
    </div>;
}